import React from "react";
import { GoogleLogin } from "react-google-login";
import { post } from "../../common/api";
import { useHistory } from 'react-router';
import { LIWAT_GOOGLE_CLIENT_ID } from "../constants";

export function GoogleSignUpButton(props) {
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(false);
    const onSuccess = async (googleResp) => {
        console.log('onSuccess: ', googleResp);
        const id_token = googleResp.getAuthResponse().id_token;
        console.log('id_token: ', id_token);
        setIsLoading(true);
        try {
            const response = await post('api/auth/sign-up-with-google', { google_id_token: id_token });
            console.log(response);
            window.alert('Success sign up with google, token: ', response.data.token);
            history.push('/login');
        } catch (e) {
            console.log(e);
            window.alert(`${e}: ${JSON.stringify(e.response?.data)}`);
        }
        setIsLoading(false);
    }

    const onFailure = (googleResp) => {
        console.log(`onFailed: ${JSON.stringify(googleResp)}`);
        window.alert('Something went wrong with Google Sign In')
    }
    return <GoogleLogin
        onSuccess={onSuccess}
        onFailure={onFailure}
        clientId={LIWAT_GOOGLE_CLIENT_ID}
        buttonText={isLoading ? "Loading" : "Daftar dengan Google"}
        disabled={isLoading}
        cookiePolicy={'single_host_origin'}
    />;
}